import React from 'react';
import * as utils from "../utils";
import ModalDialog from './ModalDialog';
//import {getDataFromLocalBackend} from "../utils";


function deactivateConsent(id, ssn, organization_no) {
    console.log("organization_no: " + organization_no);
    //alert("organization_no: " + organization_no);

    const url = window.location.href + "/api/v2/consent/deactivate";
    var jsonString = {"id": id, "ssn": ssn, "organization_no": organization_no};
    var json = JSON.stringify(jsonString);
    console.log("json: " + json);

    fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: json
    })
        .then(function (response) {
            if (response.status !== 201) {
                throw new Error(response.status);
            }
            return response.json();
        })
        .then((data) => {
            console.log('Success:', data);

            utils.getDataFromLocalBackend();

            console.log('** after getDataFromLocalBackend **');


        })
        //Then with the error genereted...
        .catch((error) => {
            console.error('Error:', error);
            alert("Oppheving av samtykke feilet!");
        });
}


//Aktive samtykker
class ConsentActive extends React.Component {
    constructor(props) {
        console.log("constructor props: " + props)
        super(props);

        this.state = {
            show: false,
            title: '',
            body: '',
            data:{}
        };
    }


    handleShow(id, ssn, organization_no) {

        const consentId = {
                id: id,
                ssn: ssn,
                organization_no: organization_no
        };

        //consentId.id

        console.log("handleShow id: " + id)
        console.log("handleShow ssn: " + ssn)
        console.log("handleShow organization_no: " + organization_no)

        this.setState({
            show: true,
            title: 'Opphev samtykke',
            body: 'Er du sikker på at du vil oppheve samtykket?',
            data: consentId
        });
    };

    handleClose = (fromModal) => {
        //alert(fromModal.msg);
        console.log("fromModal.msg: " + fromModal.msg)
        this.setState({
            show: false
        });

        if (fromModal.msg === 'ja') {
            console.log("kall slett: " + fromModal.msg)

            console.log("fromModal.data.id: " + fromModal.data.id)
            console.log("fromModal.data.ssn: " + fromModal.data.ssn)
            console.log("fromModal.data.organization_no: " + fromModal.data.organization_no)

            deactivateConsent(fromModal.data.id, fromModal.data.ssn, fromModal.data.organization_no);

        }





    };






    render() {

        var consents = this.props.loans;
        var indexType = this.props.indexType;


        if (consents.errorMessage === undefined) {
            return <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
                <div>
                    <div className="d-xl-none">
                        <div key={indexType} className='card-body list padding-0'>
                            <table className="tableLoanCol">
                                <tbody>
                                {consents.map((consent, indexConsent) => {
                                    return (
                                        <React.Fragment>
                                            <tr className={utils.tableStripes(indexConsent, false)}>
                                                <th>Virksomhet - organisasjonsnummer</th>
                                                <td className="bold">{consent.organization_name} - {consent.organization_no}</td>
                                            </tr>
                                            <tr className={utils.tableStripes(indexConsent, false)}>
                                                <th>Logg</th>
                                                <td>Utløper {consent.to_date}</td>
                                            </tr>
                                            <tr className={utils.tableStripes(indexConsent, false)}>
                                                <th>&nbsp;</th>
                                                <td>
                                                    <button className="buttonBlue" type="button" onClick={() => {
                                                        this.handleShow(consent.id, consent.ssn, consent.organization_no)
                                                    }}>Opphev samtykke
                                                    </button>
                                                </td>
                                            </tr>
                                            {consent.log.map(function (log, logIndex) {
                                                var sisteRad = logIndex + 1 === consent.log.length;
                                                return (
                                                    <tr className={utils.tableStripes(indexConsent, sisteRad)}>
                                                        <td>{log.timestamp}</td>
                                                        <td>{log.message}</td>
                                                    </tr>
                                                )
                                            })}
                                        </React.Fragment>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="d-none d-xl-block">
                        <div key={indexType} className='card-body list padding-0'>
                            <table className="tableConsentRow">
                                <tbody>
                                <tr>
                                    <th className="headerLeft height35 widthConsentCol1">Virksomhet - organisasjonsnummer</th>
                                    <th className="headerLeft height35 widthConsentCol2">Logg</th>
                                    <th className="headerLeft height35 widthConsentCol3">&nbsp;</th>
                                </tr>
                                </tbody>
                                {consents.map(consent => {
                                        return (
                                            <tbody key={consent.id}>
                                            <tr>
                                                <td className="cellLeftBold height35">{consent.organization_name} - {consent.organization_no}</td>
                                                <td className="cellLeft height35">Utløper {consent.to_date}</td>
                                                <td className="cellLeft height35">
                                                    <button className="buttonBlue float-md-left" type="button" onClick={() => {
                                                        this.handleShow(consent.id, consent.ssn, consent.organization_no)
                                                    }}>Opphev samtykke
                                                    </button>
                                                </td>
                                            </tr>
                                            {consent.log.map(log => {
                                                return (
                                                    <tr>
                                                        <td className="cellLeft height25 ">&nbsp;</td>
                                                        <td className="cellLeft height25 dotted-border-bottom">{log.timestamp}</td>
                                                        <td className="cellLeft height25 dotted-border-bottom">{log.message}</td>
                                                    </tr>
                                                )
                                            })}
                                            </tbody>
                                        )
                                    }
                                )}
                            </table>
                        </div>
                    </div>
                    <ModalDialog show={this.state.show} title={this.state.title} body={this.state.body} data={this.state.data}
                                 onClick={this.handleClose} onHide={this.handleClose}/>
                </div>
            </div>


        } else {
            return <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
                <div>
                    <span className="updatetMarkingInfo">!&nbsp;</span><span className="accordionMessage">Visning av samtykke er ikke tilgjengelig for øyeblikket, prøv igjen senere</span>
                </div>
            </div>
        }
    }
}

export default ConsentActive;